export class Tier {
  label;
  tierName;
  maxConcurrentUsers;
  monthlyFee;
  queryAllowance;
  overageCharge;
}
